import { Bell } from 'lucide-react';

interface MessagePreviewProps {
  title: string;
  body: string;
  link: string;
}

/**
 * Indicative renders of how the broadcast lands: the exchange-ui in-browser notification and
 * a mobile push card. The form's maxLength caps input at the server truncation limits, so
 * what previews here is what ships.
 */
export const MessagePreview = ({ title, body, link }: MessagePreviewProps) => (
  <div className="flex flex-col gap-3">
    <p className="text-xs uppercase tracking-wide text-muted-foreground">Preview (indicative)</p>
    <div className="flex flex-col gap-1.5">
      <p className="text-xs text-muted-foreground">Web</p>
      <div className="flex items-start gap-3 rounded-lg border bg-card p-3 shadow-sm">
        <Bell aria-hidden className="mt-0.5 size-4 shrink-0 text-blue-400" />
        <div className="min-w-0">
          <p className="truncate text-sm font-medium">{title || 'Title'}</p>
          <p className="line-clamp-3 text-sm text-muted-foreground">{body || 'Body'}</p>
          {link ? <p className="mt-1 truncate text-xs text-blue-400">{link}</p> : null}
        </div>
      </div>
    </div>
    <div className="flex flex-col gap-1.5">
      <p className="text-xs text-muted-foreground">App</p>
      <div className="rounded-2xl bg-zinc-900 p-3 text-zinc-100">
        <div className="flex items-center gap-2">
          <span className="flex size-5 items-center justify-center rounded-md bg-emerald-500 text-[10px] font-bold text-white">OT</span>
          <span className="text-xs text-zinc-400">One Trading · now</span>
        </div>
        <p className="mt-1.5 truncate text-sm font-semibold">{title || 'Title'}</p>
        <p className="line-clamp-2 text-sm text-zinc-300">{body || 'Body'}</p>
      </div>
    </div>
  </div>
);
MessagePreview.displayName = 'MessagePreview';
